export default {
    meta: {
        isShowHeader: false,
        title: 'PMS应用登录授权',
    },
};
